import React, { useEffect } from 'react'
import { Col, Descriptions, Row } from 'antd'
import { DetailDrawer } from 'Components/common/MainLayout'
import styled from 'styled-components'
import { selectCurrentUser } from 'Store/user/selector'
import RootState from 'typings/RootState'
import { connect, useDispatch } from 'react-redux'
import { LoadingView } from 'Components/modal'
import { formatDateTime, numberWithComma } from 'helpers/format'
import { MyTheme } from 'Components/common/Theme'
import { getPackageLogsAPI } from 'Store/pos/api'
import { PackageLogReq, PackageLogData } from 'Store/pos/types'
import { selectPackageLogs } from 'Store/pos/selector'

type Props = {
  isShow: boolean
  onClose: () => void
  id: number
} & ReduxProps

const PackageLog = (props: Props) => {
  const { isShow, onClose, currentUser, id, packageLog } = props

  const dispatch = useDispatch()

  const onGetDataList = (): void => {
    const req: PackageLogReq = {
      id: id,
    }
    dispatch(getPackageLogsAPI(req, currentUser.accessToken, currentUser?.activeMerchant?.id || ''))
  }

  useEffect(() => {
    if (isShow) {
      onGetDataList()
    }
  }, [isShow, id])

  return (
    <DetailDrawer
      title={`ประวัติการซื้อ`}
      width={'50%'}
      onCloseDrawer={onClose}
      visible={isShow}
      footer={null}
      maskClosable={true}
    >
      <LoadingView isShow={packageLog.event.IsLoading} />
      <Row gutter={[16, 32]}>
        {packageLog.data.map((data: PackageLogData, index: number) => {
          return (
            <Col span={24} key={index}>
              <Descriptions
                title={<Title>วันที่ซื้อ {formatDateTime(data?.created_at || '') || '-'}</Title>}
                bordered
                column={{ xxl: 2, xl: 2, lg: 2, md: 2, sm: 1, xs: 1 }}
              >
                <Descriptions.Item label="ชื่อแพ็กเกจ" span={2}>
                  <Text>{data?.package.name || ''}</Text>
                </Descriptions.Item>
                <Descriptions.Item label="จำนวนวัน">
                  <Text>{data?.package.day} วัน</Text>
                </Descriptions.Item>
                <Descriptions.Item label="ราคา">
                  <Text>{numberWithComma(data?.package.price || 0)} บาท</Text>
                </Descriptions.Item>
                <Descriptions.Item label="วันที่เริ่มใช้งาน">
                  <Text>{formatDateTime(data?.start_date || '') || '-'}</Text>
                </Descriptions.Item>
                <Descriptions.Item label="วันที่หมดอายุ">
                  <Text>{formatDateTime(data?.end_date || '') || '-'}</Text>
                </Descriptions.Item>
              </Descriptions>
            </Col>
          )
        })}
      </Row>
    </DetailDrawer>
  )
}

const Text = styled.div`
  font-size: ${(props: { theme: MyTheme }): string => props.theme.typography.body4};
`

const Title = styled(Text)`
  font-size: ${(props: { theme: MyTheme }): string => props.theme.typography.body3};
  color: ${(props: { theme: MyTheme }): string => props.theme.colors.primary};
`

const mapStateToProps = (state: RootState) => {
  return {
    currentUser: selectCurrentUser(state),
    packageLog: selectPackageLogs(state),
  }
}

type ReduxProps = ReturnType<typeof mapStateToProps>

export default connect(mapStateToProps)(PackageLog)
